import React, { useEffect, useState } from "react";
import { Grid, Header, Button, Form } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import { userData } from "../store/userData";
import { reduxForm, Field } from "redux-form";
const CompanyEmpListWithCat = (props) => {
  const { categoryId } = props;
  const navigate = useNavigate();
  const userDectail = userData();
  const isAdmin = userDectail?.userRole === 1;
  const [excelData, setexcelData] = useState([]);
  const [rowData, setrowData] = useState([]);

  useEffect(() => {
    getContactList();

    console.log("userDectail", userDectail.userId);

    console.log("categoryId", categoryId);
  }, []);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const filterDataSearch = () => {
    const fromDateObj = new Date(fromDate);
    fromDateObj.setHours(0, 0, 0, 0); // Set time to midnight
    const toDateObj = new Date(toDate);
    toDateObj.setHours(23, 59, 59, 999); // Set time to end of day

    const filteredData = excelData.filter((data) => {
      // Parse the date string into a Date object
      const dateParts = data.applicationDate.split("/");
      const parsedDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
      parsedDate.setHours(0, 0, 0, 0); // Set time to midnight

      return parsedDate >= fromDateObj && parsedDate <= toDateObj;
    });

    setexcelData(filteredData);
    setrowData(filteredData);
  };

  const getContactList = () => {
    axios
      .post(BaseUrlInvoice + "accounts/listCompanyEmployee", {
        userId: userDectail.userId,
        categoryId: categoryId,
        getAll: categoryId == 0 ? true : false,
      })
      .then((res) => {
        console.log(res.data);

        // setDataForExcel(res.data);
        // const updatedRowData = res.data.map((item) => ({
        //   ...item,
        //   applicationDate: item.applicationDate
        //     ? new Date(item.applicationDate).toLocaleDateString("en-GB")
        //     : "",
        // }));

        setrowData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //   const setDataForExcel = (record) => {
  //     const tempRecord = record.map(
  //       ({
  //         ssVisaId,
  //         serialNumber,
  //         applicationDate,
  //         customerName,
  //         applicantName,
  //         passportNumber,

  //         nationality,

  //         visaType,
  //         visaCost,
  //         invoice,
  //         id,
  //         remarks,
  //       }) => ({
  //         ssVisaId,
  //         serialNumber,
  //         applicationDate: applicationDate
  //           ? new Date(applicationDate).toLocaleDateString("en-GB")
  //           : "",
  //         customerName,
  //         applicantName,
  //         passportNumber,
  //         nationality,

  //         visaType,
  //         visaCost,
  //         invoice,
  //         id,
  //         remarks,
  //       })
  //     );

  //     setexcelData(tempRecord);
  //   };
  const defaultColDef = {
    sortable: true,
    editable: true,
    // flex: 1,
    filter: true,
    floatingFilter: true,
  };

  const columnDefs = [
    { headerName: "F-Name", field: "firstName" },
    { headerName: "M-Name", field: "middleName" }, //customerName
    { headerName: "L-Name", field: "lastName" },
    { headerName: "Country", field: "country" },

    {
      headerName: "Edit/Delete",
      filter: false,
      field: "companyEmployeeId",
      cellRendererFramework: (params) => (
        <div>
          <Button
            color="primary"
            disabled={!isAdmin}
            onClick={() => isAdmin && updateRecord(params)}
          >
            <AiFillEdit />
          </Button>
          <Button
            color="red"
            disabled={!isAdmin}
            onClick={() => isAdmin && deleteRecord(params)}
          >
            <AiFillDelete />
          </Button>
        </div>
      ),
    },
  ];

  const updateRecord = (params) => {
    navigate(
      `/create-company-employee/${params.data.companyEmployeeId}/${categoryId}`
    );
  };
  const deleteRecord = (params) => {


    console.log("params.data.ssContactId", params.data.companyEmployeeId)
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(BaseUrlInvoice + "accounts/deleteCompanyEmployee", {
            companyEmployeeId: params.data.companyEmployeeId,
          })
          .then((res) => {
            console.log("res", res.data);
            Swal.fire("Deleted!", " Recored has been deleted.", "success");
            getContactList();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  return (
    <div>
      <br />
      <Grid.Row>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            {categoryId != 0 && (
              <Button
                color="primary"
                onClick={() =>
                  navigate(`/create-company-employee/null/${categoryId}`)
                }
              >
                Create New
              </Button>
            )}

            {/* <Button
              color="primary"
              onClick={(e) => exportToCSV(excelData, "Visa_List")}
            >
              Export Excel
            </Button> */}
          </div>
        </div>
      </Grid.Row>
      <br />
      <Grid.Row>
        <div className="ag-theme-alpine" style={{ height: 600 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
          ></AgGridReact>
        </div>
      </Grid.Row>
    </div>
  );
};

export default CompanyEmpListWithCat;
